<template>
  <div class="gallery">
    <img :key="i" v-for="(img, i) in smallGallery" :src="img" @click="openPopup"/>
    <company-gallery-popup v-if="selectedImage"
      :image="selectedImage"
      @close="closePopup"
      @next="goToNext"
      @prev="goToPrev"></company-gallery-popup>
  </div>
</template>

<script>
  import companyGalleryPopup from './companyGalleryPopup'

  export default {
    name: 'companyGallery',
    components: {companyGalleryPopup},
    props: ['images'],
    data () {
      return {
        selectedImage: null,
        index: 0
      }
    },
    computed: {
      smallGallery () {
        return this.images.map(i => `${this.$store.state.config.baseURL}${i.small}`)
      },
      largeGallery () {
        return this.images.map(i => `${this.$store.state.config.baseURL}${i.large}`)
      }
    },
    methods: {
      openPopup (e) {
        const targetImage = e.target.getAttribute('src')
        this.index = this.smallGallery.indexOf(targetImage)
        this.selectedImage = this.largeGallery[this.index]
      },
      closePopup () {
        this.selectedImage = null
      },
      goToNext () {
        this.index = this.index === this.largeGallery.length - 1 ? 0 : this.index + 1
        this.selectedImage = this.largeGallery[this.index]
      },
      goToPrev () {
        this.index = this.index === 0 ? this.largeGallery.length - 1 : this.index - 1
        this.selectedImage = this.largeGallery[this.index]
      }
    }
  }
</script>

<style scoped>
  .gallery {
    font-size: 0;
  }

  .gallery img {
    width: 100%;
    margin-bottom: 10px;
  }
</style>
